import { Box, Typography } from "@mui/material";
import ThinkingMessage from "../shared/ThinkingMessage";
import ErrorMessage from "../shared/ErrorMessage";
import UserMessage from "../shared/UserMessage";
import VersionMessage from "../shared/VersionMessage";
import ChatMessageBubble from "../shared/ChatMessageBubble";

const ChatMessage = ({
  message,
  currentImageUrl,
  onImageSelect,
  isFirstUserMessage = false,
}) => {
  const getMessageContent = () => {
    if (message.isThinking) {
      return <ThinkingMessage content={message.content} />;
    }

    if (message.version) {
      return (
        <VersionMessage
          content={message.content}
          isSelected={currentImageUrl === message.imageUrl}
          onSelect={() => {
            if (message.imageUrl) {
              onImageSelect(message.imageUrl);
            }
          }}
          isInteractive={Boolean(message.imageUrl)}
        />
      );
    }

    if (message.isError) {
      return <ErrorMessage content={message.content} />;
    }

    if (message.role === "user") {
      return (
        <UserMessage
          content={message.content}
          imageUrl={message.imageUrl}
          attachmentUrls={message.attachmentUrls || []}
          attachmentFileNames={message.attachmentFileNames || {}}
          isFirstUserMessage={isFirstUserMessage}
          onImageClick={() => {
            if (message.imageUrl) {
              onImageSelect(message.imageUrl);
            }
          }}
        />
      );
    }

    return (
      <Box>
        <Typography variant="body2">{message.content}</Typography>
      </Box>
    );
  };

  return (
    <ChatMessageBubble message={message}>
      {getMessageContent()}
    </ChatMessageBubble>
  );
};

export default ChatMessage;
